export default "__VITE_ASSET__DhPuGPw0__"